function getOrdinal(n) {
    let suffix = 'th';
    if (n % 100 < 11 || n % 100 > 13) {
        switch (n % 10) {
        case 1: suffix = 'st'; break;
        case 2: suffix = 'nd'; break;
        case 3: suffix = 'rd'; break;
        }
    }
    return n + suffix;
}

document.addEventListener('DOMContentLoaded', () => {
    window.dataLayer = window.dataLayer || [];
    let allPromotions = [];

    // Push view_promotions event with all visible promos on the page
    (function() {
        const allContainers = Array.from(document.querySelectorAll('.dl-container'));
        const promotionName = document.getElementById('promo-name')?.dataset.promoName || window.location.pathname.split('/').pop();

        // Only include visible containers
        const visibleContainers = allContainers.filter(container => {
            const computedStyle = window.getComputedStyle(container);
            return computedStyle.display !== 'none';
        });

        let promoIndex = 0;
        const promotions = [];
        
        visibleContainers.forEach((container) => {
            const promotionCreative = container.getAttribute('data-promotion-id');
            const firstChild = container.firstElementChild;
            const hasGridCellInnerClass = Array.from(firstChild.classList).some(className => 
                className.startsWith('xy-grid-container')
            );
            
            if (hasGridCellInnerClass) {
                // Handle grid containers - treat each cell as its own banner
                const gridCells = firstChild.querySelectorAll('.xy-grid-cell');
                gridCells.forEach((cell, cellIndex) => {
                    promoIndex++;
                    const cellImg = cell.querySelector('img');
                    const cellImgSrc = cellImg ? cellImg.src : "https://cdn.shopify.com/s/files/1/2170/8465/files/placeholder.jpg?v=1759779720";
                    const cellLinkText = cell?.dataset?.promotionId || null;

                    promotions.push({
                        'promotionName': `${promotionName} ${getOrdinal(promoIndex)} Banner`,
                        'promotionCreativeName': cellLinkText || promotionCreative,
                        'promotionId': cellImgSrc,
                        'promotionIndex': promoIndex,
                        'promotionPosition': promotionName,
                        'promotionType': 'gtm_banner',
                    });
                });
            } else {
                // Handle regular containers
                promoIndex++;
                const img = container.querySelector('img');
                const imgSrc = img ? img.src : "https://cdn.shopify.com/s/files/1/2170/8465/files/placeholder.jpg?v=1759779720";
                const position = promoIndex;
                promotions.push({
                    'promotionName': `${promotionName} ${getOrdinal(position)} Banner`,
                    'promotionCreativeName': promotionCreative,
                    'promotionId': imgSrc,
                    'promotionIndex': position,
                    'promotionPosition': promotionName,
                    'promotionType': 'gtm_banner'
                });
            }
        });

        if (promotions.length > 0) {
            window.dataLayer.push({
                'event': 'view_promotion',
                'promotions': promotions,
                '_clear': true
            });
            allPromotions = promotions;
        }
    })();

    // Listen for clicks on links or buttons inside .dl-container
    document.querySelectorAll('.dl-container').forEach(container => {
        container.addEventListener('click', function(event) {
            if (event.target.tagName === 'FS-PRODUCT-WIDGET') {
                return;
            }
            let target = event.target;
            let buttonText = '';
            let parentContainer = target.closest('[data-promotion-id]');
            let parentA = target.closest('a');


            if (target.classList.contains('multi-cta-button')) {
                buttonText = target.dataset.linkTitle;

            } else if (parentA && parentA.classList.contains('multi-cta-button')) {
                buttonText = parentA.dataset.linkTitle;
            } 
            else if (parentContainer.querySelectorAll('.multi-fallback-link').length > 0) {
                buttonText = 'Whole Banner';
            }

            const promotions = allPromotions.filter(promotion => promotion.promotionCreativeName.toLowerCase() === parentContainer.dataset.promotionId.toLowerCase());

            if (promotions.length > 0) {
                if (buttonText !== '') {
                    promotions[0] = {...promotions[0], promotionButton: buttonText};
                }

                window.dataLayer.push({
                    'event': 'select_promotion',
                    'promotions': promotions[0],
                    '_clear': true
                });
            }

        });
    });
});
